namespace GeniuzPOS.ReportMasterData {
    export interface Report_1407Form {
    }

    export class Report_1407Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1407';
    }
}
